import axios from "../../apiFc24";

export const getAuthors = async () => {
  const res = await axios.get("/tactics/authors");
  return res.data;
};
